import { render, staticRenderFns } from "./TransactionToggle.vue?vue&type=template&id=e63a0450&scoped=true&"
import script from "./TransactionToggle.vue?vue&type=script&lang=js&"
export * from "./TransactionToggle.vue?vue&type=script&lang=js&"
import style0 from "./TransactionToggle.vue?vue&type=style&index=0&id=e63a0450&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63a0450",
  null
  
)

export default component.exports